export default "__VITE_ASSET__CBmIe4Pi__"